var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlueGallery = function SvgBlueGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 925,
    height: 460,
    viewBox: "0 0 925 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M845.085 409.006C1180.69 385.406 360.256 -143.07 187.032 38.247C13.8079 219.564 -120.154 379.759 169.125 435.665C458.403 491.572 509.479 432.606 845.085 409.006Z",
    fill: "#A5D2FB",
    fillOpacity: 0.15
  })));
};
export default SvgBlueGallery;